import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@mui/material/Typography';
import Pagination from '@mui/material/Pagination';
import Box from '@mui/material/Box';
import PrintIcon from '@mui/icons-material/Print';
import IconButton from '@mui/material/IconButton';
import { useSelector, useStore } from 'react-redux';

interface PaginationRowProps {
  total: number;
  selected: number;
  classes?: {
    hidePrint: string;
  };
  handlePrint?: () => void;
  loading: boolean;
}

export default function PaginationRow({ classes, total, selected, handlePrint, loading }: PaginationRowProps) {
  const store = useStore();
  const limit = useSelector((state: any) => state?.parcel?.parcelTableLimit);
  const sortBy = useSelector((state: any) => state?.parcel?.parcelTableSort);
  const page = useSelector((state: any) => state?.parcel?.parcelTablePage);
  return (
    <TableHead className={classes?.hidePrint}>
      <TableRow style={{ backgroundColor: '#F8F9F9' }}>
        <TableCell colSpan={2} align="left">
          <Typography sx={{ fontWeight: 'bold' }} variant="button">
            Total: {total}
          </Typography>
        </TableCell>
        <TableCell colSpan={3}>
          <Typography sx={{ fontWeight: 'bold' }} variant="button">
            Selected: {selected}
          </Typography>
        </TableCell>
        <TableCell colSpan={9} align="right">
          <div
            style={{
              display: 'flex',
              justifyContent: 'end',
              alignItems: 'center',
            }}
          >
            <Pagination
              disabled={loading}
              color="primary"
              count={Math.ceil(total / limit)}
              variant="outlined"
              shape="rounded"
              page={page}
              onChange={(e, page) => {
                store.dispatch({ type: 'UPDATE_PARCEL_TABLE_PAGE', payload: page });
              }}
            />

            <Box sx={{ px: 2 }}>
              <label htmlFor="limit">Set limit:</label>
              <select
                disabled={loading}
                onChange={(e: any) => {
                  store.dispatch({ type: 'UPDATE_PARCEL_TABLE_LIMIT', payload: e.target.value });
                  store.dispatch({ type: 'UPDATE_PARCEL_TABLE_PAGE', payload: 1 });
                }}
                style={{ cursor: 'pointer', padding: '5px' }}
                defaultValue={limit}
                value={limit}
              >
                <option value={10}>10</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={150}>150</option>
                <option value={250}>250</option>
                <option value={500}>500</option>
                <option value={1000}>1000</option>
              </select>
            </Box>
            <Box>
              <label htmlFor="sort">Sort by:</label>
              <select
                disabled={loading}
                value={sortBy}
                onChange={(e: any) => {
                  store.dispatch({ type: 'UPDATE_PARCEL_TABLE_SORT', payload: e.target.value });
                  store.dispatch({ type: 'UPDATE_PARCEL_TABLE_PAGE', payload: 1 });
                }}
                style={{ cursor: 'pointer', padding: '5px' }}
              >
                <option value={'id:ASC'}>Old to New</option>
                <option value={'id:DESC'}>New to Old</option>
                <option value={'updated_at:DESC'}>Last Update</option>
              </select>
            </Box>
            {typeof handlePrint === 'function' && (
              <div style={{ padding: '0 5px 5px' }}>
                <IconButton aria-label="PrintIcon" color="default" onClick={handlePrint}>
                  <PrintIcon />
                </IconButton>
              </div>
            )}
          </div>
        </TableCell>
      </TableRow>
    </TableHead>
  );
}
